/** Exams that are free-to-access (no subscription required). */
export const freeExams: string[] = ["GPEPAU"];
